import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

interface SelfSearchBVProps extends SvgIconProps {
  primaryColor?: string;
  secondaryColor?: string;
}

export function SelfSearchBV({
  primaryColor = '#EDEBFF',
  secondaryColor = '#E2DFFF',
  ...props
}: SelfSearchBVProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 47 45" width="44" height="45">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.0903 44.3038C43.1654 44.3037 43.2403 44.2943 43.3131 44.2756C43.8006 44.1511 44.0955 43.6523 43.9718 43.1616L42.879 38.7617C42.3598 36.629 40.7889 34.9141 38.7192 34.2205L30.6344 31.5182C28.7348 30.7189 27.846 27.5527 27.6547 26.3519C29.1515 25.1058 30.1152 23.3284 30.3466 21.3872C30.3466 20.7382 30.5379 20.4723 30.6399 20.421C30.9006 20.3532 31.1074 20.1539 31.1863 19.8948C31.7108 18.6162 32.04 17.265 32.1625 15.8872C32.1628 15.8124 32.1537 15.7378 32.1352 15.6654C32.0048 15.1302 31.6922 14.658 31.2519 14.3307V9.47049C31.0528 4.49327 27.0899 0.504238 22.1453 0.303833H21.8548C16.9102 0.504238 12.9473 4.49327 12.7482 9.47049V14.3307C12.3077 14.658 11.9952 15.1302 11.8648 15.6654C11.8464 15.7378 11.8373 15.8124 11.8375 15.8872C11.9601 17.265 12.2892 18.6162 12.8138 19.8948C12.8926 20.1539 13.0994 20.3532 13.3602 20.421C13.4621 20.4723 13.6534 20.7382 13.6534 21.3872C13.8849 23.3284 14.8486 25.1058 16.3452 26.3519C16.1541 27.5527 15.2653 30.7189 13.3657 31.5182L5.28079 34.2205C3.21116 34.9141 1.64028 36.629 1.12104 38.7617L0.0281676 43.1616C-0.0954537 43.6523 0.199342 44.1511 0.686912 44.2756C0.759651 44.2943 0.834609 44.3037 0.909738 44.3038H43.0903Z"
        fill={primaryColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.3135 44.2755C43.2401 44.2944 43.1658 44.3038 43.0907 44.3038H22V0.303833H22.1451C27.09 0.504067 31.053 4.49329 31.2519 9.47079V14.3306C31.6925 14.658 32.0049 15.1306 32.1356 15.6652C32.1535 15.7382 32.1629 15.8121 32.1629 15.8869C32.0399 17.2653 31.7112 18.6163 31.1862 19.895C31.1077 20.1537 30.9002 20.3531 30.6398 20.4209C30.5382 20.4725 30.347 20.7381 30.347 21.3869C30.1156 23.3282 29.1517 25.1063 27.6551 26.3523C27.8464 27.5529 28.7351 30.7188 30.6347 31.5181L38.7196 34.2208C40.789 34.9143 42.3599 36.6288 42.879 38.7617L43.9717 43.1617C44.0955 43.6524 43.801 44.1518 43.3135 44.2755Z"
        fill={secondaryColor}
      />
    </SvgIcon>
  );
}
